export enum Role {
  User = 'user',
  ClientAdmin = 'client-admin',
  NxtsoftDev = 'nxtsoft-dev',
  NxtsoftOp = 'nxtsoft-operations',
  NxtsoftSales = 'nxtsoft-sales',
  SuperAdmin = 'super-admin'
}
